import { styleConstants } from '@paywithextend/components'
import styled from 'styled-components'

export const NotificationDot = styled.span`
  height: 13px;
  width: 13px;
  border-radius: 50%;
  position: absolute;
  z-index: 3;
  background-color: ${styleConstants.colors.red};
  top: 18px;
`
